import { useSelector } from "react-redux";
import type { IQuickLinksSharepoint } from "../InterfacesTypes/interfaces";
import { selectQuickLinks, selectTitleTexts } from "state/selectors/Selectors";
import { getEnvironment } from "utils/utils";
import { TooltipComponent } from "./toolTipComponent/TooltipComponent";
import TitleComponent from "./TitleComponent";
import { STARTPAGETITLES } from "InterfacesTypes/enums";

const QuickLinks = () => {
  const env = getEnvironment();
  const quickLinksItems = useSelector(selectQuickLinks);
  const titleTexts = useSelector(selectTitleTexts);
  const sortedQuickLinks = [...quickLinksItems].sort(
    (a, b) => (a.LinkOrder ?? 0) - (b.LinkOrder ?? 0)
  );

  const quickLinkTitle = titleTexts.find(x => x.TitlePosition === STARTPAGETITLES.QUICKLINKSTITLE);

  return (
    <>
      <section className="flex justify-center w-full my-2">
        <div id="startpageQuicklinks" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {quickLinkTitle?.Description ?
            <TooltipComponent
              placement="top"
              className="col-span-2 sm:col-span-3! md:col-span-4! lg:col-span-5! xl:col-span-6!"
              tooltipClassName="!w-full !max-w-full"
              content={quickLinkTitle?.Description}
            >
              <TitleComponent
                title={quickLinkTitle?.Title ?? "Titel saknas"}
              className=""
              />
            </TooltipComponent>
            :
            <TitleComponent
              title={quickLinkTitle?.Title ?? "Titel saknas"}
              className=""
            />

          }
          {sortedQuickLinks.length > 0 &&
            sortedQuickLinks.map((icon: IQuickLinksSharepoint) => (
              <TooltipComponent
              className="inline-flex! justify-center!"
                key={icon.Id}
                content={icon?.Description}
                placement="top"
              >
                <a
                  key={icon.Title}
                  className="flex flex-col items-center justify-center no-underline 
                text-transparent 
                bg-[rgba(255,255,255,0.21)] rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] 
                backdrop-blur-[20px] border border-white/53 
                transform transition-transform 
                hover:-translate-y-[2px] 
                !p-2 !mx-0"
                  href={icon.Link}
                >
                  <div
                    className="!w-[150px] !h-[150px] !px-10 !py-6
                  relative isolate rounded-[16px]
                  grid place-items-center
                  !bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
                  !border border-[rgba(255,255,255,0.18)]
                  !backdrop-blur-[8px] backdrop-saturate-[120%]
                  !shadow-[0_10px_20px_rgba(0,0,0,0.25),inset_0_1px_0_rgba(255,255,255,0.12)]
                  transition-[transform,box-shadow,border-color] duration-[220ms] ease
                  hover:-translate-y-[3px] hover:!shadow-[0_14px_28px_rgba(0,0,0,0.35)] hover:!border-white
                  focus-within:-translate-y-[3px] focus-within:!shadow-[0_14px_28px_rgba(0,0,0,0.35)] focus-within:!border-white
                  hover:!bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
                  focus-within:!bg-[radial-gradient(120%_120%_at_0%_0%,rgba(255,255,255,0.14),rgba(255,255,255,0.04)_40%,rgba(255,255,255,0.02)_60%),linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))]
                  "
                  >
                    <img
                      className="!w-[70px] !h-[80px] object-contain drop-shadow-[0_1px_2px_rgba(0,0,0,0.35)] opacity-95 !mb-6"
                      src={`${env.imageUrl}/${icon.Image}`}
                      alt={icon.Title}
                    />
                    <span className="absolute left-[6px] right-[6px] bottom-3 font-medium tracking-[0.2px] whitespace-nowrap overflow-hidden text-ellipsis pointer-events-none leading-[1.2] text-center opacity-95 text-sm text-[rgb(44,43,43)]">
                      {icon.Title}
                    </span>
                  </div>
                </a>
              </TooltipComponent>
            ))}
        </div>
      </section >
    </>
  );
};
export default QuickLinks;
